import { Injectable, ViewChild } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import 'rxjs';
//import {Connection} from "@angular/http";
//import {Network} from "@ionic-native/network";
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import * as CryptoJS from "crypto-js";
import { AngularWebStorageModule, LocalStorageService } from 'angular-web-storage';
import { IHttpOptions, IRequestOptions } from '../interfaces/http-interface';


//import { SecureStorage, SecureStorageObject } from '@ionic-native/secure-storage';
@Injectable({
  providedIn: 'root'
})
export class ApiService {

  userEmail: any;
  userLocation: string;
  userName: string;



  //apiUrl="http://mfcslcif.cloudapp.net/MFCSL_Development2/api/";
  apiUrl = "https://mmfss-econnectweb.azurewebsites.net/api/";
  data: any = {};
  networkState: any;
  public loading: any;
  public detailValue: any;
  public messageSource = new BehaviorSubject<any>(this.detailValue);
  public networkmessageSource = new BehaviorSubject<any>(this.networkState)
  state: any;
  public tokenid: any;
  abc: any;

  constructor(public http: HttpClient, public _storage: LocalStorageService) {

    this.detailValue = this.messageSource.asObservable();
    this.networkState = this.networkmessageSource.asObservable();
    this.networkState.subscribe((data) => {
      this.state = data;
    });
    //  this._storage.set('dddd', { a: 1, now: +new Date })

    // let user = { firstName: 'Henri', lastName: 'Bergson' };

    // this._storage.set('user', user).subscribe(() => {});


  }



  getCurrentTime() {
    // if (this.state) {
    return new Promise((resolve, reject) => {
      this.getHeaders().then((authtoken: any) => {
        this.http.get(this.apiUrl, { headers: authtoken, observe: 'response' })
          .subscribe(res => {
            // this.refreshToken(res.headers.get('authtoken'));
            resolve(res.body);
          }, error => {
            reject(error.statusText);
          });
      });
    })

  }

  postData(postUrl, params) {
    // return new Promise((resolve, reject)=>{
    //   this.http.post(postUrl,params).subscribe((res: any)=>{
    //     resolve(res);
    //   }, error=>{
    //     reject(error);
    //   })
    // })


    return new Promise((resolve, reject) => {
      this.getHeaders().then((authHeaders: any) => {
        console.dir('autheaders');
        console.dir(authHeaders);

        let headers = new HttpHeaders(authHeaders);
        // let data= JSON.stringify(params)
        this.http.post(postUrl, params).subscribe((res: any) => {
          //  this.validateResponse(res.headers.get('Authorization'));
          // this.validateResponse("testAuthtoken1");
          resolve(res);
        }, error => {
          reject(error);
        });
      });

    });





  }

  deleteData(postUrl, params?) {

    let httpOptions = {}

    if (params) {
      httpOptions = {
        body: params
      };

    }
    return new Promise((resolve, reject) => {
      this.getHeaders().then((authHeaders: any) => {
        this.http.delete(postUrl, httpOptions)
          .subscribe((res: any) => {
            resolve(res);
          }, error => {
            reject(error);
          })
      });
    })

  }

  putData(postUrl, params) {
    return new Promise((resolve, reject) => {
      let headers = new HttpHeaders()
      this.http.put(postUrl, params)
        .subscribe((res: any) => {
          resolve(res);
        }, error => {
          reject(error);
        })
    })
  }

  getData(postUrl, params?) {
    debugger
    return new Promise((resolve, reject) => {
      this.getHeaders().then((authHeaders: any) => {
        let headers = new HttpHeaders(authHeaders);
        // let data= JSON.stringify(params)
        this.http.get(postUrl, { params, headers }).subscribe((res: any) => {
          //  this.validateResponse(res.headers.get('Authorization'));
          this.validateResponse("testAuthtoken");
          resolve(res);
        }, error => {
          reject(error);
        });
      });

    });

  }

  get(url: string, headers?: any, params?: any, options?: IHttpOptions) {
    return this.http.get(url, <any>this.getRequestOptions(headers, params, options));
}

  private getRequestOptions(headers?: any, params?: any, options?: IHttpOptions): IRequestOptions {
    debugger
    headers = headers || {};
    params = params || {};
    options = options || {};

    if (!headers['Content-Type']) {
        headers['Content-Type'] = 'application/json';
    }
    const customHeader = new HttpHeaders(headers);

    const customParams = new HttpParams();
    for (const key of Object.keys(params)) {
        customParams.append(key, params[key]);
    }
    const requestOptions = Object.assign({}, options);
    requestOptions['headers'] = customHeader;
    requestOptions['params'] = customParams;
    return requestOptions;
}
  decrypt(plain_text) {
    let promise = new Promise(resolve => {
      try {
        let key = CryptoJS.enc.Utf8.parse("S@LT&P@@sW0rDkEY");
        let iv = CryptoJS.enc.Utf8.parse("@1B2c3D4e5F6g7H8");
        let decrypted: any;
        decrypted = CryptoJS.AES.decrypt(plain_text, key, {
          iv: iv
        });
        let decrypted_text = decrypted.toString(CryptoJS.enc.Utf8);
        resolve(decrypted_text);
      } catch (error) {
        console.log(error);
      }
    });

    return promise;
  }

  encrypt(plain_text) {
    console.dir(plain_text);
    let promise = new Promise(resolve => {
      try {
        let key = CryptoJS.enc.Utf8.parse("S@LT&P@@sW0rDkEY");
        let iv = CryptoJS.enc.Utf8.parse("@1B2c3D4e5F6g7H8");
        let encrypted = {};
        encrypted = CryptoJS.AES.encrypt(plain_text, key, {
          iv: iv
        });
        let encrypted_text = encrypted["ciphertext"].toString(
          CryptoJS.enc.Base64
        );
        resolve(encrypted_text);
      } catch (error) {
        console.log(error);
      }
    });
    return promise;
  }




  // getHeaders() {
  //   let promise = new Promise((resolve) => {
  //       resolve({ 
  //           'Content-Type': 'application/json; charset=utf-8',
  //           'Access-Control-Allow-Origin':'*' ,
  //           'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
  //           'Access-Control-Allow-Headers': 'accept, cache-control, content-type, authorization'
  //         });
  //   });
  //   return promise;
  // }

  getHeaders() {
    let promise = new Promise(resolve => {
      this.getSecureToken().then(
        (dt: any) => {
          if (dt == null)
            resolve({ "Content-Type": "application/json", platform: "m" });
          else
            resolve({ "Content-Type": "application/json; charset=utf-8" });
          resolve({
            "Content-Type": "application/json",
            Authorization: "Bearer " + dt,
            platform: "m"
          });
        },
        err => { }
      );
    });
    return promise;
  }

  validateResponse(arg: any): any {
    this._storage.set('AuthToken', arg);
    //this.encrypt(arg).then((dt) => {
    // this._storage.set('userToken', arg);
    //  })
  }


  getSecureToken() {
    let promise = new Promise(resolve => {

      let userdata = this._storage.get('AuthToken');
      console.dir(userdata);
      if (userdata) {
        resolve(userdata);
      } else {
        resolve(null);
      }
      // this._storage.get("AuthToken").then(userdata => {
      //   userdata = JSON.parse(userdata);
      //   console.dir(userdata);
      //   if(userdata){
      //     resolve(userdata);
      //   }else{
      //     resolve(null);
      //   }
      //     // this.decrypt(userdata).then(
      //     //   (dt: any) => {
      //     //     dt = JSON.parse(dt);
      //     //     resolve(dt.authtoken);
      //     //   },
      //     //   err => {
      //     //     resolve(null);
      //     //   }
      //     // );
      //   },
      //   err => {
      //     console.dir(err);
      //     resolve(null);
      //   } );
    });
    return promise;
  }



  dismissLoading() {
    this.loading.dismiss();
  }
  // savetoken(data) {
  //   this.userToken = data;
  //   console.log('TOKEN', this.userToken);
  // }

}



